import React from 'react';
import { useRouteMatch } from 'react-router-dom';

const Layout = ({ children }) => {
  const isComp = useRouteMatch('/app/competition');

  return (
    <div className={`h-100 ${isComp ? 'fullscreen' : ''}`}>
      {children}
    </div>
  );
};

export default Layout;
